// src/pages/Settings/api.ts

import api from "../../app/api";

const getSettingsInfo = () => {
  return api.get("/setting/get-all.php");
};

const saveSettingsInfo = (payload: object) => {
  return api.post("/setting/save.php", payload);
};

// New: Crontab API functions
const getCrontab = () => {
  return api.get("/setting/get_crontab.php");
};

const saveCrontab = (entries: string[]) => {
  return api.post("/setting/save_crontab.php", { entries });
};

const SettingsApi = {
  getSettingsInfo,
  saveSettingsInfo,
  getCrontab,
  saveCrontab,
};

export default SettingsApi;